/* Block styles */
import "./block.scss";

/**
 * The core button block will not be using the default styles and will instead
 * be using custom styles.
 */
wp.domReady(function () {
    const sidebarAuthors = Array.from(
        document.querySelectorAll(".sidebar__author-container")
    );

    if (sidebarAuthors) {
        // Create and append author modal to end of body
        const authorModal = document.createElement("div");
        const overlay = document.createElement("div");
        authorModal.classList.add("sidebar__author-modal");
        overlay.classList.add("sidebar__overlay");
        document.body.appendChild(authorModal);
        document.body.appendChild(overlay);

        // Append content to modal on click
        sidebarAuthors.forEach((author) => {
            // Show author modal
            const authorExpand = author.querySelector(
                ".sidebar__author-expand"
            );
            authorExpand.addEventListener("click", () => {
                const authorContent = author.innerHTML;
                authorModal.innerHTML = authorContent;
                authorModal.classList.add("sidebar__author-modal--show");
                authorModal.style.zIndex = "1001";
                overlay.classList.add("sidebar__overlay--show");
                overlay.style.zIndex = "1000";
            });
        });

        // Check to see if author modal content changes
        let observer = new MutationObserver(() => {
            // Hide author modal
            const authorClose = authorModal.querySelector(
                ".sidebar__author-close"
            );
            authorClose.addEventListener("click", () => {
                authorModal.classList.remove("sidebar__author-modal--show");
                setTimeout(function () {
                    authorModal.style.zIndex = "-1";
                }, 300);
                overlay.classList.remove("sidebar__overlay--show");
                setTimeout(function () {
                    overlay.style.zIndex = "-1";
                }, 300);
            });
            overlay.addEventListener("click", () => {
                authorModal.classList.remove("sidebar__author-modal--show");
                setTimeout(function () {
                    authorModal.style.zIndex = "-1";
                }, 300);
                overlay.classList.remove("sidebar__overlay--show");
                setTimeout(function () {
                    overlay.style.zIndex = "-1";
                }, 300);
            });
        });
        observer.observe(authorModal, {
            characterData: false,
            childList: true,
            attributes: false,
        });
    }
});
